import eventosMenu from './eventos/menu';
import contasEventosMenu from './contasEventos/menu';
import credenciamentoMenu from './credenciamento/menu';
import feiraMenu from './feiraempreendedor/menu';
import expositoresMenu from './expositores/menu';
import certificadosMenu from './certificados/menu';
import impressorasMenu from './impressoras/menu';
import leituraQRCodeMenu from './impressoras/menuLeituraQRCode';
import guicheMenu from './guiche/menu';

const menu = {
    label: 'Webster',
    icon: 'pi pi-fw pi-id-card',
    rules: [...eventosMenu.rules, ...contasEventosMenu.rules, ...credenciamentoMenu.rules, ...feiraMenu.rules, ...certificadosMenu.rules, ...expositoresMenu.rules, ...impressorasMenu.rules, ...leituraQRCodeMenu.rules, ...guicheMenu.rules],
    items: [eventosMenu, contasEventosMenu, credenciamentoMenu, feiraMenu, certificadosMenu, expositoresMenu, leituraQRCodeMenu, impressorasMenu, guicheMenu],
};

export default menu;
